import { __awaiter } from "tslib";
import Animation from "../../Animation";
export default class FlashWire extends Animation {
    constructor(from, to) {
        super();
        this._name = "FlashWire";
        this.from = from;
        this.to = to;
    }
    action(ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            return ctx.wires.component.flashWire(this.from, this.to);
        });
    }
    toString() {
        return `${super.toString()}, from: ${this.from}, to: ${this.to}`;
    }
}
